import React, {CSSProperties, useCallback, useRef} from "react";
import {getTrackBackground, Range as ReactRange} from "react-range";
import {IRenderTrackParams} from "react-range/lib/types";
import classNames from "classnames";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useIsMounted} from "@pg-mono/hooks";

import {useValuesWithTransformation} from "../hooks/use_values_with_transformation";
import {IRange} from "../types/IRange";
import {RangeType} from "../types/RangeType";
import {UnitsType} from "../types/UnitsType";
import {getLabelFromExtremum} from "../utils/get_label_from_extremum";

import * as cns from "./SlimRange.module.css";

interface IProps {
    name: string;
    value: IRange<RangeType>;
    error?: string[];
    onChange: (fieldName: string, value: IRange<RangeType>) => void;
    step: number;
    min: number;
    max: number;
    unitType?: UnitsType;
    useDynamicChange?: boolean;
    hideLabels?: boolean;
    className?: string;
    disabled?: boolean;
    useTwoSides?: boolean;
    centerValue?: number;
    useStepChange?: boolean;
}

export const SlimRange = (props: IProps) => {
    const {value, min, max, step, disabled, unitType = UnitsType.NUMBERS, useDynamicChange, className, useTwoSides, centerValue, useStepChange = false} = props;
    const rangeRef = useRef<ReactRange>(null);

    const {sliderValues, sliderStep, minimum, maximum, setSliderValues, mapToRealValue} = useValuesWithTransformation(
        value,
        step,
        min,
        max,
        centerValue,
        useStepChange,
        useDynamicChange
    );

    const renderTrackCallback = useCallback(
        ({props: trackProps, children}: IRenderTrackParams) => {
            return (
                <div onMouseDown={trackProps.onMouseDown} onTouchStart={trackProps.onTouchStart} className={cns.slimRangeTrack}>
                    <div
                        ref={trackProps.ref}
                        className={cns.slimRangeTrackContent}
                        style={
                            {
                                "--track-bg": getTrackBackground({
                                    values: sliderValues,
                                    // values: sliderNumbers.value,
                                    colors: getTrackBgColors(props.value),
                                    min: minimum,
                                    max: maximum
                                })
                            } as CSSProperties
                        }
                    >
                        {children}
                    </div>
                </div>
            );
        },
        [sliderValues, minimum, maximum, value]
    );

    const isMounted = useIsMounted();
    if (!isMounted) {
        return null;
    }

    return (
        <div className={classNames(className)}>
            <ReactRange
                disabled={disabled}
                ref={rangeRef}
                onFinalChange={(values) => {
                    const newValues = centerValue ? values.map((el) => mapToRealValue(el)) : values;
                    if (useTwoSides) {
                        props.onChange(props.name, {
                            lower: newValues[0],
                            upper: newValues[1]
                        });
                        return;
                    }
                    /**
                     * TODO Like in Range, that makes it actually a single value range, like a "SlimMaxRange"
                     *  We should change the name or implementation
                     */
                    props.onChange(props.name, {
                        lower: 0,
                        upper: newValues[0]
                    });
                }}
                onChange={(value) => {
                    setSliderValues(value);
                    const transformedValue = centerValue ? value.map((el) => mapToRealValue(el)) : value;

                    if (useTwoSides && useDynamicChange) {
                        props.onChange(props.name, {
                            lower: transformedValue[0],
                            upper: transformedValue[1]
                        });
                        return;
                    }
                    if (useDynamicChange) {
                        props.onChange(props.name, {lower: 0, upper: transformedValue[0]});
                    }
                }}
                values={sliderValues}
                step={sliderStep}
                min={minimum}
                max={maximum}
                renderTrack={renderTrackCallback}
                renderThumb={({props}) => (
                    <div {...props} key={props.key} style={props.style} className={cns.slimRangeThumbWrap}>
                        <div className={cns.slimRangeThumb}></div>
                    </div>
                )}
            />
            {!props.hideLabels && (
                <div className={cns.slimRangeThumbLabel}>
                    <Text variant="info_txt_2" align="left" className={cns.slimRangeThumbLabelText}>
                        {`Od ${getLabelFromExtremum(unitType, min)}`}
                    </Text>
                    <Text variant="info_txt_2" align="right" className={cns.slimRangeThumbLabelText}>
                        {`Do ${getLabelFromExtremum(unitType, max)}`}
                    </Text>
                </div>
            )}
        </div>
    );
};

// Utils
function getTrackBgColors(value: IProps["value"]) {
    if ("lower" in value && "upper" in value) {
        return [getThemeVariable("colors.gray.300"), getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
    }

    return [getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
}
import React, {CSSProperties, useCallback, useRef} from "react";
import {getTrackBackground, Range as ReactRange} from "react-range";
import {IRenderTrackParams} from "react-range/lib/types";
import classNames from "classnames";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useIsMounted} from "@pg-mono/hooks";

import {useValuesWithTransformation} from "../hooks/use_values_with_transformation";
import {IRange} from "../types/IRange";
import {RangeType} from "../types/RangeType";
import {UnitsType} from "../types/UnitsType";
import {getLabelFromExtremum} from "../utils/get_label_from_extremum";

import * as cns from "./SlimRange.module.css";

interface IProps {
    name: string;
    value: IRange<RangeType>;
    error?: string[];
    onChange: (fieldName: string, value: IRange<RangeType>) => void;
    step: number;
    min: number;
    max: number;
    unitType?: UnitsType;
    useDynamicChange?: boolean;
    hideLabels?: boolean;
    className?: string;
    disabled?: boolean;
    useTwoSides?: boolean;
    centerValue?: number;
    useStepChange?: boolean;
}

export const SlimRange = (props: IProps) => {
    const {value, min, max, step, disabled, unitType = UnitsType.NUMBERS, useDynamicChange, className, useTwoSides, centerValue, useStepChange = false} = props;
    const rangeRef = useRef<ReactRange>(null);

    const {sliderValues, sliderStep, minimum, maximum, setSliderValues, mapToRealValue} = useValuesWithTransformation(
        value,
        step,
        min,
        max,
        centerValue,
        useStepChange,
        useDynamicChange
    );

    const renderTrackCallback = useCallback(
        ({props: trackProps, children}: IRenderTrackParams) => {
            return (
                <div onMouseDown={trackProps.onMouseDown} onTouchStart={trackProps.onTouchStart} className={cns.slimRangeTrack}>
                    <div
                        ref={trackProps.ref}
                        className={cns.slimRangeTrackContent}
                        style={
                            {
                                "--track-bg": getTrackBackground({
                                    values: sliderValues,
                                    // values: sliderNumbers.value,
                                    colors: getTrackBgColors(props.value),
                                    min: minimum,
                                    max: maximum
                                })
                            } as CSSProperties
                        }
                    >
                        {children}
                    </div>
                </div>
            );
        },
        [sliderValues, minimum, maximum, value]
    );

    const isMounted = useIsMounted();
    if (!isMounted) {
        return null;
    }

    return (
        <div className={classNames(className)}>
            <ReactRange
                disabled={disabled}
                ref={rangeRef}
                onFinalChange={(values) => {
                    const newValues = centerValue ? values.map((el) => mapToRealValue(el)) : values;
                    if (useTwoSides) {
                        props.onChange(props.name, {
                            lower: newValues[0],
                            upper: newValues[1]
                        });
                        return;
                    }
                    /**
                     * TODO Like in Range, that makes it actually a single value range, like a "SlimMaxRange"
                     *  We should change the name or implementation
                     */
                    props.onChange(props.name, {
                        lower: 0,
                        upper: newValues[0]
                    });
                }}
                onChange={(value) => {
                    setSliderValues(value);
                    const transformedValue = centerValue ? value.map((el) => mapToRealValue(el)) : value;

                    if (useTwoSides && useDynamicChange) {
                        props.onChange(props.name, {
                            lower: transformedValue[0],
                            upper: transformedValue[1]
                        });
                        return;
                    }
                    if (useDynamicChange) {
                        props.onChange(props.name, {lower: 0, upper: transformedValue[0]});
                    }
                }}
                values={sliderValues}
                step={sliderStep}
                min={minimum}
                max={maximum}
                renderTrack={renderTrackCallback}
                renderThumb={({props}) => (
                    <div {...props} key={props.key} style={props.style} className={cns.slimRangeThumbWrap}>
                        <div className={cns.slimRangeThumb}></div>
                    </div>
                )}
            />
            {!props.hideLabels && (
                <div className={cns.slimRangeThumbLabel}>
                    <Text variant="info_txt_2" align="left" className={cns.slimRangeThumbLabelText}>
                        {`Od ${getLabelFromExtremum(unitType, min)}`}
                    </Text>
                    <Text variant="info_txt_2" align="right" className={cns.slimRangeThumbLabelText}>
                        {`Do ${getLabelFromExtremum(unitType, max)}`}
                    </Text>
                </div>
            )}
        </div>
    );
};

// Utils
function getTrackBgColors(value: IProps["value"]) {
    if ("lower" in value && "upper" in value) {
        return [getThemeVariable("colors.gray.300"), getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
    }

    return [getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
}
